var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", {
    staticClass: "comps-audit-log-modal-table-title",
    domProps: { textContent: _vm._s(_vm.title) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }